/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { OrphanedSessionDto } from './orphaned-session-dto';
import { RescheduleConflictDto } from './reschedule-conflict-dto';
 /**
 *
 *
 * @export
 * @interface PlanningReferencesDto
 */
export interface PlanningReferencesDto {

    /**
     * The therapy being edited
     *
     * @type {JoinEntityDto}
     * @memberof PlanningReferencesDto
     */
    assignment: JoinEntityDto;

    /**
     * The proposed start date (SQL date), echoed back
     *
     * @type {string}
     * @memberof PlanningReferencesDto
     * @example 2026-08-12
     */
    startAt: string;

    /**
     * The proposed end date (SQL date), echoed back
     *
     * @type {string}
     * @memberof PlanningReferencesDto
     * @example 2026-08-19
     */
    endAt: string;

    /**
     * Whether the edit would be accepted: the therapy is still editable, the range is valid, no session is left outside and nothing collides.
     *
     * @type {boolean}
     * @memberof PlanningReferencesDto
     */
    allowed: boolean;

    /**
     * Whether the planning edit is open at all. False once the therapy's own status leaves SCHEDULED — which happens when a session is actually started, NOT when one is moved or cancelled.
     *
     * @type {boolean}
     * @memberof PlanningReferencesDto
     */
    editable: boolean;

    /**
     * Whether the proposed end date precedes the start date
     *
     * @type {boolean}
     * @memberof PlanningReferencesDto
     */
    invalidRange: boolean;

    /**
     * Live sessions that would fall outside the proposed window. Cancelled sessions and superseded shells are not listed: they weigh nothing anywhere else either.
     *
     * @type {Array<OrphanedSessionDto>}
     * @memberof PlanningReferencesDto
     */
    outside: Array<OrphanedSessionDto>;

    /**
     * Sessions of the member's OTHER therapies that the shifted plan would overlap. Empty when the start date does not move, since nothing moves.
     *
     * @type {Array<RescheduleConflictDto>}
     * @memberof PlanningReferencesDto
     */
    conflicts: Array<RescheduleConflictDto>;
}
